import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class ClassGroupIntermediateIndexRoute extends Route 
{
	@service router;
	
	redirect(model)
	{
		this.router.transitionTo('event.class-group.intermediate.results',model);
	}
}